export const REVIEWRATINGLIST ="REVIEWRATINGLIST"
export const REVIEWRAATINGDELETE = "REVIEWWRATINGDELETE"